import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-logo">
              <img src="/logo.jpeg" alt="JANM Engineering" />
              <span>JANM<em>Engineering</em></span>
            </div>
            <p>
              JANM Engineering Pvt Ltd is a next-generation software company building scalable SaaS platforms,
              AI-powered systems, and enterprise-grade APIs for startups and businesses worldwide.
            </p>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">SaaS Development</a></li>
              <li><a href="#services">AI &amp; RAG Systems</a></li>
              <li><a href="#services">API Infrastructure</a></li>
              <li><a href="#services">Web &amp; Mobile Apps</a></li>
              <li><a href="#services">Enterprise Automation</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><a href="#home">About Us</a></li>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#cta">Contact</a></li>
              <li><a href="#cta">Careers</a></li>
              <li><a href="#cta">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} JANM Engineering Pvt Ltd. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/janm_labs?utm_source=qr&igsh=YnE4Y2FxbXluMWNt" target="_blank" rel="noreferrer">Instagram</a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
